const tw = {
	aqqewad:'安全密碼需6-20位',
	qsrzz: '請輸入整數',
	黄金: '黃金',
	美元: '美元',
	原油: '原油',
	数值: '數值',
	caijinj: '彩金',
	djlfjj: '提交認證',
	sutfufk: '認證碼將會寄至您的信箱',
	hoafaa: '發送認證碼',
	reqawao: '信箱認證',
	renzyao: '認證要求',
	weirenzz: '未認證',
	dhjzg: 'L1 認證',
	shiabais: '提現失敗',
	chongzzi: '儲值失敗',
	zhengsong: '贈送',
	shouyi: '收益',
	chenggong: '成功',
	lunm: '輪',
	mmcuowu: '密碼不正確',
	qmiia: '安全密碼必須是6位數字',
	至尊: '至尊',
	贵宾: '貴賓',
	专业: '專業',
	普通: '普通',
	基础: '基礎',
	gunqq: '成功',
	fwwq: '複製失敗',
	fuz: '復製成功',
	shangpin: '上傳憑證',
	fuzz: '複製',
	erwei: '二維碼',
	pipeii: '請輸入地址',
	pipei: '匹配地址',
	shuruu: '輸入金額',
	touzichenggong: '投資成功',
	tzjebndyzhye: '投資金額不能大於帳戶餘額',
	tzjebnxy: '投資金額不能小於1',
	qxztzlx: '請選擇投資類型',
	shurujine: '輸入金額',
	huiyuan: '會員',
	moshi: '模式',
	touzi: '投資',
	zhtz: '組合投資',
	lsjl: '歷史記錄',
	lunjieguo: '輪結果',
	sycj: '剩餘時間',
	jxz: '進行中',
	ljcj: '立即儲值',
	tzze: '投資總額',
	yffje: '已發放金額',
	zxrs: '線上人數',
	涨: '漲',
	大涨: '大漲',
	小涨: '小漲',
	跌: '跌',
	大跌: '大跌',
	小跌: '小跌',
	tjiao: '提交',
	xuaze: '選擇頭像',
	textee21: '傳送國際電子郵件至support-gold@fgold.org',
	textee20: '意見與申訴：',
	textee19: '問題解答：請聯絡國際線上客服',
	textee18: 'Forex Gold USA的團隊將不懈努力為使您能得到一切所需資訊，以便更好地探索、使用我們的平台，將其帶給您帶來的收益最大化。 如果用戶仍有任何問題，都可以隨時與我們聯絡。',
	textee17: '每一個用戶對我們來說都是最重要的。',
	textee16: '聯絡我們',
	textee15: '4.操作的隱藏性和彈性',
	textee14: '3.籌資方式的私募性',
	textee13: '2.投資效果的高報酬性',
	textee12: '1.投資活動的便利性',
	textee11: '特點：',
	textee10: '作為業界的國際領導企業之一，Forex Gold USA已在全球贏得30多項享有盛譽的獎項。無論是在成熟市場，或是新興市場，憑藉我們的創新及服務，Forex Gold USA的領先地位每一年都在不斷加強。',
	textee9: '為了客戶能獲得超凡的交易體驗，Forex Gold USA也為每位參與交易的客戶進行了盈利的長期不定時的更新平台優化建設。 Forex Gold USA為全球來自110多個國家的用戶提供優質服務。',
	textee8: 'Forex Gold USA是一款便捷、隱蔽、高回報的投資交易軟體，量子基金投資20億美元聯合紐約證券交易所（USA），納斯達克證券交易所（NASDAQ），倫敦證券交易所（LDN）等數十個全球各大交易所，透過數據挖掘，對各大期貨商品交易的加權平均值做運算衍生的黃金、美金、原油截止2023年12月，Forex Gold USA的全球用戶數超過5543萬，平均回報率約29.30%。',
	textee7: 'Forex Gold USA',
	textee6: '4.原油和大豆，糖等：德州原油、杜倫特原油。',
	textee5: '3.黃金白銀等貴金屬：倫敦金、鉑金、鈀金、銀、銅、等等貴金屬交易。',
	textee4: '2.外匯：美元對人民幣（離岸人民幣），歐元兌美元、歐元/日圓、歐元/紐元、英鎊兌美元、美元/日圓、美元/加幣等等24小時。',
	textee3: '2013年4月1日納斯達克斥資7.5億美元（約58.5億港元）現金，向貨幣經紀商BGC Partners收購電子債券交易平台eSpeed，令納市可首次涉足每日交投量達5000億美元的市場，若收入符合目標，納斯達克將在未來15年發行價值4.84億美元的市場，若收入符合目標，納斯達克將在未來15年發行價值4.84億美元的普通股。',
	textee2: '1.指數期貨：納斯達克、德國法蘭克福指數、法國CAC-40指數、歐盟50指數、日經指數、香港恆生國企指數、ASX 200指數、瑞典股票30等，美元指數USDOLLAR，香港恆生指數、道瓊工業指數、倫敦富時100、標準普爾500、所有產品申請',
	textee1: 'Forex Gold USA是一家為投資黃金、美金、原油即時國際價漲跌組合金融投資業務的著名環球交易服務供應商。集團成立於1997年，20多年來始終如一地經營自己的誠信品牌，以良好的聲譽與優質的服務成為全球投資者的首選。Forex Gold USA通過納斯達克、美國、倫敦、國際金融中心提供同步數據，以專業的不同品類交易視角為全球不同國家地區用戶提供一切需要的圖表及數據，讓用戶輕鬆隨時進行交易。零點差、每日推送交易訊號、良好的交易體驗讓Forex Gold USA榮獲全球30多項交易大獎，成為全世界超過5543萬用戶的交易首選。',
	anquan1: '修改安全密碼',
	touzijl: '投資記錄',
	yirenz: '已認證',
	ldn5: '最終LDN的20170508001輪結果為：7+4+5=16（漲）（小漲）',
	ldn4: 'LDN採集英國倫敦證券交易所等數十個全球各大交易所，透過數據挖掘，對各大期貨商品交易的加權平均值做計算衍生的黃金、美金、原油投資產品的國際實時價格波動漲跌值，時間全體24小時，每5分鐘賦值更新一輪，投資模式為6種組合簡單投資模式，分別歸類與黃金、美金、原油三種價格波動值組合結果為（0-13）為跌，（14-27）為漲，（0-6）為大跌，（7-13）為小跌，（14-20）為小漲，（21-27）為大漲。',
	ldn3: 'LDN投資說明：',
	ldn2: 'LDN是英國倫敦證券交易所等數十個全球各大交易所，透過資料挖掘，對各大期貨商品交易的加權平均值做計算衍生的黃金、美金、原油投資產品的國際即時價格波動漲跌值組合AQ的投資結果每5分鐘的加權平均值換算出的結果，最終結果換算為三個（0－9）的數字之和，總共有28種結果（0－27）。',
	ldn1: 'LDN是什麼',
	usa5: '最終USA的20170508001輪結果為：7+4+5=16（漲）（小漲）',
	usa4: 'USA採集美國紐約證券交易所等數十個全球各大交易所，透過數據挖掘，對各大期貨商品交易的加權平均值做計算衍生的黃金、美金、原油投資產品的國際實時價格波動漲跌值，時間全體24小時，每3分鐘賦值更新一輪，投資模式為6種組合簡單投資模式，分別歸類與黃金、美金、原油三種價格波動值組合結果為（0-13）為跌，（14-27）為漲，（0-6）為大跌，（7-13）為小跌，（14-20）為小漲，（21-27）為大漲。',
	usa3: 'USA投資說明：',
	usa2: 'USA是美國紐約證券交易所等數十個全球各大交易所，透過數據挖掘，對各大期貨商品交易的加權平均值做計算衍生的黃金、美金、原油投資產品的國際即時價格波動漲跌值組合AQ的投資結果每3分鐘的加權平均值換算出的結果，最終結果換算為三個（0－9）的數字之和，總共有28種結果（0－27）。',
	usa1: 'USA是什麼',
	nasd9: '最終NASDAQ的20170508001輪結果為：7+4+5=16（漲）（小漲）',
	nasd8: '2017年5月8日09：05計算原油漲跌數據賦予的值為：5',
	nasd7: '2017年5月8日09：05計算出美金漲跌數據賦予的值為：4',
	nasd6: '2017年5月8日09：05計算出黃金漲跌資料賦予的值為：7',
	nasd5: '例如：',
	nasd4: 'NASDAQ採集納斯達克證券交易所等數十個全球各大交易所，透過資料挖掘，對各大期貨商品交易的加權平均值做計算衍生的黃金、美金、原油投資產品的國際即時價格波動漲跌值，時間全體24小時，每1分鐘賦值更新一輪，投資模式為6種組合簡單投資模式，分別歸類與黃金、美金、原油三種價格波動值組合結果為（0-13）為跌，（14-27）為漲，（0-6）為大跌，（7-13）為小跌，（14-20）為小漲，（21-27）為大漲。',
	nasd3: 'NASDAQ投資說明：',
	nasd2: 'NASDAQ是納斯達克證券交易所等數十個全球各大交易所，通過資料挖掘，對各大期貨商品交易的加權平均值做計算衍生的黃金、美金、原油投資產品的國際實时價格波動漲跌值組合AQ的投資結果每1分鐘的加權平均值換算出的結果，最終結果換算為三個（0－9）的數位之和，總共有28種結果（0－27）。',
	nasd1: 'NASDAQ是什麼',
	text10: '帳戶等級越高，投資報酬率將會隨之越高；',
	text9: '帳戶等級分為基礎級，普通級，專業級，貴賓級，至高等級；',
	text8: '投資100美金小跌，最終的結果為小跌，則回報率為360美金；',
	text7: '投資100美金大跌，最終的結果為大跌，則回報率為360美金；',
	text6: '投資100美金小漲，最終的結果為小漲，則回報率為360美金；',
	text5: '投資100美金大漲，最終的結果為大漲，則回報率為360美金；',
	text4: '投資100美金跌，最終的結果為跌，則回報率為195美金；',
	text3: '投資100美金漲，最終的結果為漲，則回報率為195美金；',
	text2: '投資（漲），（跌），（大漲），（小漲），（大跌），（小跌）',
	text1: '低風險組合投資報酬率說明',
	ldn: '什麼是 LDN ？',
	usa: '什麼是 USA ？',
	nasd: '什麼是 NASDAQ ？',
	text: '投資規則說明',
	xitongxx: '系統消息',
	touzimx: '投資明細',
	youxiao: '請輸入有效的郵箱地址',
	liangan: '兩次安全密碼輸入不一致',
	liang: '兩次密碼輸入不一致',
	qsryz: '請輸入正確的數字驗證碼',
	tianxx: '請務必填寫好本人郵箱，否則無法正常通過驗證',
	yanzhengma: '請輸入驗證碼',
	youxiang: '郵箱',
	anquanmi: '確認安全密碼',
	anquan: '請輸入安全密碼',
	querenmma: '確認密碼',
	tijiao: '提交',
	meyou: '沒有賬號',
	zaixian: '在線客服',
	deglu: '登錄',
	jichu: '基礎',
	putong: '普通',
	zhuanye: '專業',
	guibin: '貴賓',
	chaoguibin: '至尊',
	anquanzhongxin: '安全中心',
	renzhengzx: '認證中心',
	jiaoyiguize: '交易規則',
	jinrisunyi: '今日損益',
	zican: '資產',
	jiaoyidating: '交易',
	zuiditouzi: '最低金額',
	zuidijinru: '進入標準',
	hangqing: '行情',
	jiaoyi: '交易',
	qianbao: '錢包',
	jiantizhongwen: '繁體中文',
	xianlu: '線路',
	dianwei: '當前點位',
	wodezichan: '我的資產',
	touzikuaixun: '投資資訊',
	jiaoyiyonghu: '交易用戶',
	jiaoyipinglei: '交易品類',
	danlunhuoli: '單輪獲利',
	jiaoyiriqi: '交易日期',
	dengluhouchakan: '登陸後查看',
	shouye: '首頁',
	yucun: '預存',
	zoushi: '走勢',
	wode: '我的',
	jichulicai: '基礎理財',
	zishenlicai: '資深理財',
	dashilicai: '大師理財',
	zhuanjialicai: '專家理財',
	基础理财: '基礎理財',
	资深理财: '資深理財',
	大师理财: '大師理財',
	专家理财: '專家理財',
	huiyuanquanyi: '會員權益',
	zuoriyingli: '昨日盈利',
	zongzichan: '總資產',
	chucunjin: '儲存金',
	jinriyingli: '今日盈利',
	zhuanchu: '提現',
	cunru: '充值',
	zhanghuxinxni: '賬戶信息',
	lishizhangdan: '歷史賬單',
	zijinminxi: '資金明細',
	renwuzhongxin: '任務中心',
	xiaoxigonggao: '消息公告',
	tuijianfenxiang: '推薦分享',
	huodongzhongxin: '活動中心',
	jibenziliao: '基本資料',
	dengluzhanghao: '登錄賬號',
	nicheng: '昵称',
	shezhi: '設置',
	genggaixianlu: '更改線路',
	guanyuwomen: '關於我們',
	xitongshezhi: '系統設置',
	yuyanshezhi: '語言設置',
	tuichudenglu: '退出登錄',
	bangdingyinhangka: '綁定銀行卡',
	bangdingxuniqianbao: '綁定虛擬錢包',
	anquanma: '安全碼',
	xiugailenglumima: '修改登錄密碼',
	yinhangkaguanli: '銀行卡管理',
	tianjiayinhangka: '添加銀行卡',
	xuniqianbaoguanli: '虛擬錢包管理',
	tianjiaxuniqianbao: ' 添加虛擬錢包',
	chiakren: '持卡人',
	yinhangkakahao: '銀行戶口號',
	yinhangmingcheng: '銀行名稱',
	yhkTps: '請綁定持卡人本人的銀行卡',
	nixiqianbaodizhi: '虛擬錢包地址',
	xuniqianbaoleixing: '虛擬錢包類型',
	xnqbTps: ' 溫馨提示：請填寫USDT地址類型，如：trc20、erc20、omni。',
	plchikaren: '請輸入持卡人姓名',
	plkahao: '請輸入正確的銀行戶口號',
	plyinhangmingcheng: '請輸入銀行名稱',
	plqbdz: '請輸入虛擬錢包地址',
	plqblx: '請輸入虛擬錢包類型',
	shezhianquanma: '重置安全碼',
	yuananquanma: '原安全碼',
	xinanquanma: '新安全碼',
	planquanma: '請輸入原安全碼',
	plxinanquanma: '請輸入新安全碼',
	queren: '確認',
	quxiao: '取消',
	anquanmaTps: '請設置安全碼，請勿與銀行卡密碼相同',
	anquanmaTpsTow: '尊敬的客戶，此安全碼是您轉出時的密碼，為了安全起見，請盡量不要與登錄密碼相同',
	xiugaidenglu: '修改登錄密碼',
	jiumima: '舊密碼',
	xinmima: '新密碼',
	querenmima: '確認密碼',
	pljiumima: '請輸入舊密碼',
	plxinmima: '請輸入新密碼',
	plquerenmima: '請再次輸入密碼',
	wancheng: '完成',
	kaishitouzi: '開始投資',
	kaiTps: '當前線路無法使用時，可嘗試切換其他線路',
	zuiyou: '最優',
	dangaqianxianlu: '當前線路',
	dangqianbanben: '2025年新用戶活動彩金派送中，擁有活動名額用戶可注意查收系統消息',
	banquansuoyou: '版權所有',
	yinglizhendong: '盈利震動',
	gensuixitong: '跟隨系統',
	zhuanchujine: '轉出金額',
	plzhuanchu: '請輸入轉出金額',
	zhuanchuTps: '如有疑問請聯系客服',
	xuanzeyh: '請選擇提款銀行卡',
	xuanzehb: '請選擇提款虛擬錢包',
	tijiaoshenqing: '提交申請',
	shuruanquanma: '請輸入安全碼',
	xianshangcunru: '線上存入',
	saomacunru: 'USDT',
	wangyincunru: "網銀存入",
	shijian: '時間',
	upshijian: '開始時間',
	downshijian: '結束時間',
	wuTps: '暫無相關數據~',
	jiazaicx: '重新加載',
	di: '第',
	lun: '輪',
	weiyingli: '未盈利',
	yishouli: '已受理',
	zhuangtai: '狀態',
	chongzhi: '重置',
	riqi: '日期',
	CapActive: {
		chongzhi: '充值',
		tixian: '提現',
		goumai: '购买',
		yingli: '購買',
		zengsong: '贈送',
		weitongguo: '未通過',
		yitongguo: '已通過',
		yijujue: '已拒絕',
	},
	zhanneixiaoxi: "站内消息",
	pingtaigonggao: '平臺公告',
	fuzhilanjie: "復制鏈接",
	denglu: '登錄',
	jizhumima: '記住密碼',
	wangjimima: '忘記密碼',
	youkedenglu: '遊客登錄',
	zhucezhanghao: "立即註冊",
	plusername: '請輸入用戶名',
	plpassword: '請輸入密碼',
	wanchengzhuce: '完成註冊',
	yiyouzhanghao: '已有賬戶',
	qingdenglu: '請登錄',
	zhuce: '注册',
	remenhuati: '熱門話題',
	news1: '原創',
	news2: '推薦',
	news3: '財富',
	renliulan: '人瀏覽',
	hezhi: '和值',
	lunshu: '輪數',

	做多: '做多',
	做空: '做空',
	多单: '多單',
	多双: '多雙',
	空单: '空單',
	空双: '空雙',
	平单: '極陰',
	平双: '極陰',
	极阴: '極陰',
	极阳: '極陽',
	qi: '期',
	juli: '距離',
	lunjiezhi: '輪截至',
	yifengpan: '已封盤',
	yiguanbi: '已關閉',
	yonghu: '用戶',
	danlunjiaoyi: '單輪交易',
	caozuo: '操作',
	pljoin: '加入聊天室成功',
	pltingshou: '產品已停售',
	gengou: "跟購",
	quedinggengou: "確定跟購嗎",
	wanjia: "玩家",
	leibie: "類別",
	jine: "金額",
	gouru: '購入',
	zanweigouru: '暫未購入',
	qigou: '起購',
	gourushuliang: '購入數量',
	changgui: '常規',
	shuzi: '數位',
	yinglihezhi: '盈利和值',
	shouyijieshao: '收益介紹',
	lijicunru: '立即存入',
	kaihaojieguo: '開號結果',
	kaihaoqushi: '開號趨勢',
	chanpingshuoming: '產品說明',
	qingchuhuancun: '清除緩存',
	youke: '游客',
	gongxi: '恭喜 ',
	zai: ' 在 ',
	yingli: ' 盈利 ',
	xiadanchenggong: '下單成功',
	jiazaizhong: '加載中...',
	guanbitg: '已關閉，停止購入',
	xiangoudl: '只能跟購當前輪',
	liaotiantip: '系統已禁言，請選擇購入',
	tishi: '提示',
	zhidao: '知道了',
	zhuanchusb: '轉出失敗',
	zhuanchusbs: '餘額不足，轉出失敗',
	buyxq: '購入詳情',
	orderNo: '賬單編號',
	plan_name: '廳房信息',
	buyxx: '購入信息',
	haoxx: '選號詳情',
	buysj: '購入時間',
	yilou: '遺漏',
	fzjqb: '已復製到粘貼板',
	chanpin1: '開售時間：每3.5分鐘為一輪，當日10:00AM開盤，次日02:00AM停盤。 ',
	chanpin2: '每輪有3個0-9的數字，3個數字相加為最終結果，可以投資結果做多做空平單平雙極陽極陰以及數字。 ',
	Tips: {
		wjmm: '忘記密碼請聯繫客服修改!',
		dlcg: '登錄成功',
		tjcg: '提交成功',
		zanwu: '暫無數據',
		buyizhi: '兩次密碼不一致',
		zcbz: '您的資產不足請存入',
		pltxje: '請輸入提現金額',
		zdtx: '最低提現100',
		youke: '尊敬的遊客您好：請您註冊正式會員後操作。 ',
		szcg: '設置成功',
	},
}
export default tw;